<style src="./ColumnSuppliers.scss" lang="scss" scoped></style>
<template>
  <li class="suppliers box">
    <div
      v-for="(supplier, supplierIdx) in suppliers"
      :key="supplierIdx"
      :class="{
        'supplier-selected': selections.includes(supplier.supplier._id),
        'supplier__requested': !!supplier.requestDate,
        'supplier__responded': !!supplier.receiveDate,
        'supplier__notquoted': supplier.notQuote
      }"
      @click="selectSupplier(supplier, supplierIdx)"
      class="supplier">

      {{ supplier.supplier.name }}

      <div
        v-if="supplier.isPreferred"
        class="ispreferred"
        title="Item com garantia de preço">
        <icon-star class="icon" />
      </div>

      <div class="tips">
        <span class="notquoted" v-if="supplier.notQuote">Não Cotado</span>
        <div class="fieldset">
          <span class="comercialname">{{ supplier.comercialName }}</span>
        </div>
        <div
          v-if="!!supplier.requestDate"
          class="requeststatus">
          <div class="content">
            <span class="title">Envio</span>
            <span class="value value__warning">{{ supplier.requestDate | DateBR }}</span>
          </div>
          <div class="content">
            <span class="title">Recebido</span>
            <span class="value value__success" v-if="!!supplier.receiveDate">{{ supplier.receiveDate | DateBR }}</span>
          </div>
        </div>
        <div class="fieldset">
          <span class="label">Forncededor</span>
          <span class="value">{{ supplier.supplier.name }}</span>
        </div>
        <div class="fieldset">
          <span class="label">Custo</span>
          <span class="value"><small>R$</small>{{ supplier.cost | CurrencyBR }}</span>
        </div>
        <div class="fieldset">
          <span class="label">Última compra</span>
          <span class="value">{{ supplier.lastBuyingDate | DateBR }}</span>
        </div>
        <div class="fieldset">
          <span class="label">Quantidade em Estoque</span>
          <span class="value">{{ supplier.stockQuantity | DecimalNumber }}</span>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { DecimalNumber, CurrencyBR, DateBR } from '@/components/primitives/helpers/filters'
import { IconStar } from '@/components/primitives/icons'
import { mapGetters } from 'vuex'

export default {
  name: 'ColumnItem',
  components: {
    IconStar
  },
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      selections: []
    }
  },
  computed: {
    suppliers () {
      const list = []
      this.info.suppliers && this.info.suppliers.map(i => {
        if (!list.some(l => l.supplier.name === i.supplier.name)) {
          const mappedList = { ...i }
          const supplierQuote = this.info.suppliersQuote &&
            this.info.suppliersQuote.quotations &&
            this.info.suppliersQuote.quotations.find(q => q.supplier === i.supplier._id)

          if (supplierQuote) {
            mappedList.notQuote = supplierQuote.notQuote
            mappedList.requestDate = supplierQuote.requestDate
            mappedList.receiveDate = supplierQuote.receiveDate
          }

          list.push(mappedList)
        }
      })
      return list
    },
    ...mapGetters({
      allSuppliers: 'Quote/ALL_SUPPLIERS'
    })
  },
  watch: {
    allSuppliers: {
      handler () {
        this.mountSelection()
      },
      immediate: true
    },
    info () {
      this.mountSelection()
    }
  },
  filters: {
    DecimalNumber,
    CurrencyBR,
    DateBR
  },
  methods: {
    selectSupplier (item, idx) {
      const payload = {
        itemId: this.info._id,
        supplierId: item.supplier._id
      }

      const existsIn = this.selections.indexOf(item.supplier._id)
      if (existsIn > -1) {
        this.$store.commit('Quote/REMOVE_QUOTATION', payload)
      } else {
        this.$store.commit('Quote/ADD_QUOTATION', payload)
      }
    },
    mountSelection () {
      for (const supplier in this.suppliers) {
        const supplierId = this.suppliers[supplier] && this.suppliers[supplier].supplier && this.suppliers[supplier].supplier._id
        if (supplierId) {
          const supplierSelection = this.$store.getters['Quote/SUPPLIER_BY_ID'](supplierId)
          if (supplierSelection.itemsQuoted.includes(this.info._id)) {
            const supplierPosition = this.selections.indexOf(supplierId.toString())
            if (supplierPosition === -1) {
              const selection = [ ...this.selections ]
              selection.push(supplierId.toString())
              this.selections = selection
            }
          } else {
            const supplierPosition = this.selections.indexOf(supplierId.toString())
            if (supplierPosition > -1) {
              const selections = [ ...this.selections ]
              selections.splice(supplierPosition, 1)
              this.selections = selections
            }
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-quote/components/column-suppliers/ColumnSuppliers.vue